"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Itunes = function Itunes(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.979,24c-2.483,0-4.898-0.777-6.954-2.262h0c-2.59-1.872-4.3-4.644-4.814-7.807 c-0.514-3.162,0.228-6.336,2.091-8.937c1.864-2.604,4.627-4.321,7.78-4.835c3.148-0.514,6.307,0.233,8.896,2.104 c2.59,1.872,4.3,4.644,4.815,7.807c0.514,3.162-0.228,6.336-2.091,8.938c-1.865,2.604-4.628,4.321-7.78,4.835 C13.273,23.948,12.623,24,11.979,24z M5.505,21.074c2.411,1.742,5.353,2.438,8.284,1.96c2.936-0.479,5.509-2.079,7.246-4.504 c3.583-5.004,2.445-12.004-2.538-15.604c-2.411-1.742-5.353-2.438-8.284-1.96C7.278,1.446,4.704,3.045,2.968,5.47 C-0.616,10.474,0.523,17.474,5.505,21.074L5.505,21.074z M16.111,17.522c0.731-0.214,1.246-0.734,1.458-1.468l0.062-0.216 l0.008-5.787c0.006-4.334,0-5.814-0.024-5.895c-0.025-0.086-0.066-0.157-0.118-0.214c-0.077-0.048-0.17-0.073-0.276-0.073 c-0.073,0-0.325,0.035-0.56,0.078c-1.041,0.19-7.176,1.411-7.281,1.45C9.218,5.458,9.057,5.6,8.981,5.751L8.916,5.879 c0,0-0.031,9.071-0.078,9.173c-0.071,0.155-0.23,0.303-0.376,0.35c-0.069,0.022-0.343,0.084-0.609,0.137 c-1.231,0.245-1.688,0.421-2.075,0.801c-0.22,0.216-0.382,0.51-0.453,0.819c-0.067,0.295-0.045,0.737,0.051,1.006 c0.1,0.281,0.262,0.521,0.473,0.71c0.192,0.148,0.419,0.258,0.674,0.324c0.563,0.144,1.618-0.016,2.158-0.328 c0.226-0.131,0.516-0.404,0.667-0.629c0.06-0.089,0.15-0.268,0.2-0.399c0.176-0.456,0.181-8.582,0.204-8.684 c0.038-0.174,0.157-0.301,0.32-0.344c0.147-0.039,6.055-1.207,6.222-1.23c0.146-0.02,0.284,0.027,0.36,0.12 c0.045,0.024,0.083,0.056,0.109,0.096c0.048,0.071,0.051,0.213,0.058,2.785c0.008,2.961,0.012,2.892-0.149,3.079 c-0.117,0.136-0.263,0.189-0.864,0.311c-0.914,0.187-1.226,0.275-1.576,0.446c-0.437,0.213-0.679,0.447-0.867,0.836 c-0.133,0.275-0.182,0.481-0.182,0.754c0.001,0.489,0.169,0.871,0.55,1.245c0.035,0.034,0.069,0.066,0.104,0.097 c0.192,0.148,0.387,0.238,0.633,0.294C14.84,17.73,15.594,17.673,16.111,17.522z"
  }));
};

Itunes.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Itunes.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Itunes;
exports.default = _default;